import { useEffect, useState } from "react";
import {
  useGetOrderAreaChart,
  useGetOrderCountChart,
  useGetOrderRegisterCount,
} from "../../../Production/OrderArchive/Hook";
import moment from "moment-jalaali";

const useChartOrderContainer = () => {
  const [dataLineChart, setDataLineChart] = useState([]);
  const [chartFilter, setChartFilter] = useState({ name: "mondth", enum: 1 });
  const [activeFilterType, setActiveFilterType] = useState(1);
  const [total, setTotal] = useState([]);
  const [customerFieldValue, setCustomerFieldValue] = useState(
    "00000000-0000-0000-0000-000000000000"
  );
  const [designerFiled, setDesignerFiled] = useState(
    "00000000-0000-0000-0000-000000000000"
  );
  const currentJalaliYear = moment().locale("en").format("jYYYY");
  const [year, setYear] = useState({ year: currentJalaliYear });
  const [month, setMonth] = useState({ month: 0 });
  const changeActiveFilterType = (type) => {
    setActiveFilterType(type);
  };

  const tabHandler = (type) => {
    setChartFilter(() =>
      type === "day"
        ? { name: "day", enum: 0 }
        : type === "mondth"
        ? { name: "mondth", enum: 1 }
        : { name: "year", enum: 2 }
    );
  };
  //*************************  Submit Api   ************************ */
  const { mutate, data } = useGetOrderCountChart();

  const { mutate: areaMutate, data: areaData } = useGetOrderAreaChart();

  const { mutate: registerCountMutate, data: registerData } =
    useGetOrderRegisterCount();

  //re-render
  useEffect(() => {
    const body = {
      chartReportTiming: chartFilter.enum,
      customerId: customerFieldValue,
      designerId: designerFiled,
      year: chartFilter.enum === 1 || chartFilter.enum === 0 ? year.year : 0,
      month: chartFilter.enum === 0 ? month.month : 0,
    };
    if (activeFilterType === 1) mutate(body);
    if (activeFilterType === 2) areaMutate(body);
    if (activeFilterType === 3)  registerCountMutate(body);
    
  }, [
    chartFilter,
    activeFilterType,
    customerFieldValue,
    designerFiled,
    year,
    month,
  ]);

  //*************************  Fetch data    ************************ */
  const bindData = (data) => {
    setDataLineChart(data?.data?.data.items);
    setTotal([
      {
        count: data?.data?.data?.total,
        color: "#3592FB",
        title: "سفارشات",
        key: "total_2_1",
      },
      {
        count: data?.data?.data?.total1,
        color: "rgba(154, 64, 224, 1)",
        title: "خرابی",
        key: "total_2_2",
      },
      {
        count: data?.data?.data?.total2,
        color: "rgba(76, 175, 80, 1)",
        title: "تجدید ساخت",
        key: "total_2_3",
      },
      {
        count: data?.data?.data?.total3,
        color: "rgba(255, 152, 0, 1)",
        title: "اصلاحیه",
        key: "total_2_4",
      },
      {
        count: data?.data?.data?.total4,
        color: "red",
        title: "جمع کل",
        key: "total_2_5",
      },
    ]);
  };
  useEffect(() => {
    switch (activeFilterType) {
      case 1:
        bindData(data);
        break;
      case 2:
        bindData(areaData);
        break;
      case 3:
        bindData(registerData);
        break;
      default:
        break;
    }
  }, [data, areaData, registerData]);

  return {
    dataLineChart,
    setDataLineChart,
    chartFilter,
    data,
    areaData,
    activeFilterType,
    setActiveFilterType,
    registerData,
    total,
    changeActiveFilterType,
    customerFieldValue,
    setCustomerFieldValue,
    designerFiled,
    setDesignerFiled,
    tabHandler,
    year,
    setYear,
    month,
    setMonth,
  };
};
export default useChartOrderContainer;
